<template>
  <DuoFeatures/>
</template>

<script>
// @ is an alias to /src
import DuoFeatures from '@/components/DuoFeatures.vue'

export default {
  components: {
    DuoFeatures
  }
}
</script>
